module.exports = __webpack_public_path__ + "static/img/img-login-bg.9e269e4f.png";